const numberToText = (number: number): string => {
  switch (number) {
    case 1:
      return 'One more answer'
    case 2:
      return 'Two answers'
    case 3:
      return 'Three answers'
    case 4:
      return 'Four answers'
    case 5:
      return 'Five answers'
    case 6:
      return 'Six answers'
    case 7:
      return 'Seven answers'
    case 8:
      return 'Eight answers'
    case 9:
      return 'Nine answers'
    default:
      return 'Several answers'
  }
}
export default numberToText
